import React from 'react';
import { Tabs } from 'antd';
import OrderSetting from './components/orderSetting';
import OrderAutoSetting from './components/orderAutoSetting';
import '../style.less';

export default function Index() {
  const items = [
    { label: '品类订货时间设置', key: '1', children: <OrderSetting /> }, // 务必填写 key
    { label: '订货自动提交设置', key: '2', children: <OrderAutoSetting /> },
  ];
  return (
    <Tabs defaultActiveKey="1" items={items}>
      {/* <Tabs.TabPane tab="品类订货时间设置" key="1">
        <OrderSetting />
      </Tabs.TabPane>
      <Tabs.TabPane tab="订货自动提交设置" key="2">
        <OrderAutoSetting />
      </Tabs.TabPane> */}
    </Tabs>
  );
}